module.exports = __webpack_public_path__ + "static/media/ml.c931aaa1.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ml.svg
// module id = 1297
// module chunks = 0